import { ref } from 'vue';

/** Bumped when active asset-type terminology context changes (global or record scope). */
export const terminologyRevision = ref(0);

export function bumpTerminologyRevision() {
    terminologyRevision.value += 1;
}
